<!-- src/components/OnlineGameGrid.vue -->
<script setup>
defineOptions({ name: 'OnlineGameGrid' });

import { computed } from 'vue';
import { useGamesStore } from '../../stores/games/gamesStore';

const props = defineProps({
  currentPage: {
    type: Number,
    required: true
  },
  gamesPerPage: {
    type: Number,
    required: true
  },
  isAuthenticated: {
    type: Boolean,
    required: true
  }
});

const emit = defineEmits(['show-login']);

const gamesStore = useGamesStore();
const games = computed(() => gamesStore.games);

const visibleGames = computed(() => {
  const gamesToShow = props.currentPage * props.gamesPerPage;
  return games.value.slice(0, gamesToShow);
});

const handleGameLaunch = async (gameId) => {
  if (!props.isAuthenticated) {
    emit('show-login');
    return;
  }
  try {
    await gamesStore.launchGame(gameId);
  } catch (error) {
    console.error('❌ Error launching game:', error);
  }
};
// Nueva función para manejar favoritos
const handleToggleFavorite = async (event, gameId) => {
  event.stopPropagation(); // Evitar que se propague al padre (no lanzar el juego)
  
  if (!props.isAuthenticated) {
    emit('show-login');
    return;
  }
  
  try {
    await gamesStore.toggleFavorite(gameId);
  } catch (error) {
    console.error('Error al marcar favorito:', error);
  }
};
</script>
<template>
  <div v-for="game in visibleGames"
       :key="game?.id"
       class="game-card"
       @click.stop="handleGameLaunch(game?.id)">
    <div class="game-preview">
      <img v-if="game?.image_url"
           :src="game.image_url"
           :alt="game?.game_name || 'Game image'"
      />
      <!-- Botón de favorito con estado visual -->
      <button 
        class="favorite-button"
        @click.stop="handleToggleFavorite($event, game?.id)"
        title="Marcar como favorito"
      >
        <font-awesome-icon 
          :icon="['fas', 'heart']" 
          :class="{ 'heart-favorite': game.is_favorite }" 
            :style="{ color: game.is_favorite ? '#ff3366' : 'white' }"
        />
      </button>
    </div>
    <div class="game-overlay">
      <span class="game-name">{{ game?.game_name || 'Loading...' }}</span>
      <div class="game-provider">{{ game?.provider?.name || 'Unknown' }}</div>
    </div>
  </div>
</template>

<style scoped>
@import '../../assets/styles/online/OnlineMain.css';
/* Estilos para el botón de favoritos */
.favorite-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
}

.favorite-button:hover {
  background: rgba(0, 0, 0, 0.7);
  transform: scale(1.1);
}

/* Estilo para corazón favorito */
.heart-favorite {
  color: #ff3366;
}
.text-favorite {
  color: #ff3366 !important;
}
</style>